/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     index.js
//   Details:    index.js
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 105066 06/01/20 JC  M01  Added font awesome
// 103839 06/04/20 JC  M02  React upgrade
// 108958 24/08/20 JC  M03  Default app style to 'none', will be overridden in utils.applyFrameKiller called from within App.js
// 110638 28/01/21 JC  M04  Removed ref to bootstrap-theme.css as no longer in bootstrap
//-------------------------------------------------------
*/

import 'react-app-polyfill/ie11'; //M02
import 'react-app-polyfill/stable'; //M02
import 'bootstrap/dist/css/bootstrap.css';
//M04 import 'bootstrap/dist/css/bootstrap-theme.css';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
//M02 import { ConnectedRouter } from 'react-router-redux';
import { ConnectedRouter } from 'connected-react-router'; //M02
import { history } from './history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import fontawesome from './fontawesome'; //M01

//// Create browser history to use in the Redux store
//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
//const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
        <App style={{ display: 'none' }} />  {/* M03 apply default display of 'none' */}
    </ConnectedRouter>
  </Provider>,
  rootElement);

registerServiceWorker();
